"use strict";

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextDrawer = void 0;

var Utils_1 = require("../Utils");

var Enums_1 = require("../Enums");

var TextDrawer = function () {
  function TextDrawer() {}

  TextDrawer.prototype.init = function (container) {
    var _a, _b;

    return __awaiter(this, void 0, void 0, function () {
      var options, shapeOptions, _i, shapeOptions_1, character, character;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            options = container.options;
            if (!(Utils_1.Utils.isInArray(Enums_1.ShapeType["char"], options.particles.shape.type) || Utils_1.Utils.isInArray(Enums_1.ShapeType.character, options.particles.shape.type))) return [3, 7];
            shapeOptions = (_a = options.particles.shape.options[Enums_1.ShapeType.character]) !== null && _a !== void 0 ? _a : options.particles.shape.options[Enums_1.ShapeType["char"]];
            if (!(shapeOptions instanceof Array)) return [3, 5];
            _i = 0, shapeOptions_1 = shapeOptions;
            _c.label = 1;

          case 1:
            if (!(_i < shapeOptions_1.length)) return [3, 4];
            character = shapeOptions_1[_i];
            return [4, Utils_1.Utils.loadFont(character)];

          case 2:
            _c.sent();

            _c.label = 3;

          case 3:
            _i++;
            return [3, 1];

          case 4:
            return [3, 7];

          case 5:
            character = (_b = options.particles.shape.options[Enums_1.ShapeType.character]) !== null && _b !== void 0 ? _b : options.particles.shape.options[Enums_1.ShapeType["char"]];
            if (!(character !== undefined)) return [3, 7];
            return [4, Utils_1.Utils.loadFont(character)];

          case 6:
            _c.sent();

            _c.label = 7;

          case 7:
            return [2];
        }
      });
    });
  };

  TextDrawer.prototype.draw = function (context, particle, radius, _opacity) {
    var character = particle.shapeData;

    if (character === undefined) {
      return;
    }

    var textData = character.value;

    if (textData === undefined) {
      return;
    }

    var textParticle = particle;

    if (textParticle.text === undefined) {
      if (textData instanceof Array) {
        textParticle.text = Utils_1.Utils.itemFromArray(textData, particle.randomIndexData);
      } else {
        textParticle.text = textData;
      }
    }

    var text = textParticle.text;
    var style = character.style;
    var weight = character.weight;
    var size = Math.round(radius) * 2;
    var font = character.font;
    var fill = particle.fill;
    context.font = style + " " + weight + " " + size + "px \"" + font + "\"";
    var pos = {
      x: -radius / 2,
      y: radius / 2
    };

    if (fill) {
      context.fillText(text, pos.x, pos.y);
    } else {
      context.strokeText(text, pos.x, pos.y);
    }
  };

  return TextDrawer;
}();

exports.TextDrawer = TextDrawer;